/* eslint-disable import/prefer-default-export */
import getQuery from '../../utilities/query';
import {
  bank,
  transactions,
  transfers,
  user,
  accountSettings,
  exchange,
  accounts,
} from '../../api';
import { handleError } from '../../utilities/errorHandling';
import { GET_LAST_USED_WHITELIST_ADDRESS, GET_WHITELIST_ADDRESSES } from './queries';

const queryClient = getQuery();

export const USER_CREATE_WALLET = 'user.create_wallet';
export const TRANSACTION_CALCULATE_FEES = 'transaction.calculate_fees';
export const TRANSACTION_CALCULATE_GENERIC_FEES = 'transaction.calculate_generic_fees';
export const TRANSACTION_SEND = 'transaction.send';
export const BUY_FIAT = 'pgw.buy_fiat';
export const BANK_WITHDRAW = 'bank.withdraw';
export const UPDATE_SELECTED_CURRENCY = 'account_settings.update_selected_currency';
export const WHITELIST_AUTH_EMAIL = 'user.whitelistAuthEmail';
export const WHITELIST_ADDRESSES = 'user.whitelistAddresses';
export const WHITELIST_DELETE_WALLET = 'user.whitelistDeleteAddress';

export const BUY_EXCHANGE = 'exchange.buy';
export const SELL_EXCHANGE = 'exchange.sell';
export const CONVERT_EXCHANGE = 'exchange.convert';
export const FUNDING_BANK_DETAILS_DOWNLOAD_PDF = 'transfers.funding_bank_details_pdf';
export const TRANSACTIONS_ALL = 'transactions.all';
export const EDIT_MAILING_ADDRESS = 'accounts.editMailingAddress';

export const MEXC_SELL_ESTIMATION = 'account.mexc.sell';
export const MEXC_BUY_ESTIMATION = 'account.mexc.buy';

queryClient.setMutationDefaults(MEXC_SELL_ESTIMATION, {
  mutationFn: accounts.mexc.sellEstimation,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(MEXC_BUY_ESTIMATION, {
  mutationFn: accounts.mexc.buyEstimation,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(WHITELIST_DELETE_WALLET, {
  mutationFn: user.deleteWhitelistAddress,
  onError: (error) => {
    handleError(error);
  },
  onSuccess: async () => {
    await queryClient.invalidateQueries(GET_LAST_USED_WHITELIST_ADDRESS);
    await queryClient.invalidateQueries(GET_WHITELIST_ADDRESSES);
  },
});

queryClient.setMutationDefaults(WHITELIST_AUTH_EMAIL, {
  mutationFn: user.whitelistAuthEmail,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(WHITELIST_ADDRESSES, {
  mutationFn: user.whitelistAddresses,
  onError: (error) => {
    handleError(error);
  },
  onSuccess: async () => {
    await queryClient.invalidateQueries(GET_LAST_USED_WHITELIST_ADDRESS);
    await queryClient.invalidateQueries(GET_WHITELIST_ADDRESSES);
  },
});

queryClient.setMutationDefaults(USER_CREATE_WALLET, {
  mutationFn: user.createWallet,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(TRANSACTION_CALCULATE_FEES, {
  mutationFn: transactions.calculateFees,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(TRANSACTION_CALCULATE_GENERIC_FEES, {
  mutationFn: transactions.calculateGenericFees,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(TRANSACTION_SEND, {
  mutationFn: transactions.send,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(BUY_EXCHANGE, {
  mutationFn: exchange.buy,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(SELL_EXCHANGE, {
  mutationFn: exchange.sell,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CONVERT_EXCHANGE, {
  mutationFn: exchange.convert,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(BUY_FIAT, {
  mutationFn: transactions.buyFiat,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(BANK_WITHDRAW, {
  mutationFn: bank.withdraw,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(UPDATE_SELECTED_CURRENCY, {
  mutationFn: accountSettings.updateSelectedCurrency,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(FUNDING_BANK_DETAILS_DOWNLOAD_PDF, {
  mutationFn: transfers.fundingBankDetails,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(TRANSACTIONS_ALL, {
  mutationFn: accounts.transactions,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(EDIT_MAILING_ADDRESS, {
  mutationFn: accounts.editMailingAddress,
  onError: (error) => {
    handleError(error);
  },
});
